import { Icon } from '@iconify/react';
import dashboardIcon from '@iconify/icons-ic/outline-space-dashboard';
import studentIcon from '@iconify/icons-mdi/account-box-multiple-outline';
import calenderFill from '@iconify/icons-eva/calendar-fill';
import profileSetting from '@iconify/icons-mdi/account-settings-outline';
import instituteIcon from '@iconify/icons-mdi/education-outline';
import teacherIcon from '@iconify/icons-ic/baseline-co-present';

// ----------------------------------------------------------------------
import classesIcon from '@iconify/icons-ic/round-cast-for-education';

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

const sidebarConfig = [
  {
    title: 'dashboard',
    path: '/dashboard/app',
    icon: getIcon(dashboardIcon)
  },
  {
    title: 'classes',
    path: '/dashboard/classes',
    icon: getIcon(classesIcon)
  },
  {
    title: 'teacher',
    path: '/dashboard/teacher',
    icon: getIcon(teacherIcon)
  },
  {
    title: 'students',
    path: '/dashboard/students',
    icon: getIcon(studentIcon)
  },
  {
    title: 'calender',
    path: '/dashboard/calender',
    icon: getIcon(calenderFill)
  },
  {
    title: 'account',
    path: '/dashboard/account',
    icon: getIcon(profileSetting)
  },
  {
    title: 'institute',
    path: '/dashboard/institute',
    icon: getIcon(instituteIcon)
  }
];

export default sidebarConfig;
